<button
  [type]="type"
  [disabled]="disabled"
  [ngClass]="{
    uppercase: isUppercase,
    iconOnly: isIconOnly,
    iconLeft: iconLeft,
    iconRight: iconRight
  }"
  [class]="theme"
>
  <studio-icon
    *ngIf="iconLeft"
    [name]="iconLeft"
    [direction]="iconDirection"
    [size]="iconSize"
  ></studio-icon>
  <ng-content></ng-content>
  <studio-icon
    *ngIf="iconRight"
    [name]="iconRight"
    [direction]="iconDirection"
    [size]="iconSize"
  ></studio-icon>
</button>
